import { render, staticRenderFns } from "./InformacionGeneral.vue?vue&type=template&id=63084fc9"
import script from "./InformacionGeneral.vue?vue&type=script&lang=js"
export * from "./InformacionGeneral.vue?vue&type=script&lang=js"
import style0 from "./InformacionGeneral.vue?vue&type=style&index=0&id=63084fc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports